export const BUSINESS_PERMISSIONS = {
  read: 'business.order.read',
  write: 'business.order.write',
};
